import Big from 'big.js'
import { useContext } from 'react'

import { MetronomeContext } from '../components/MetronomeContext'

const useProjectedIssuableLimitInUsd = function (
  usdRate,
  inputValue,
  operation
) {
  const {
    metronome,
    selectedPoolData: { collaterals },
    selectedToken,
    debtPosition: { issuableLimitInUsd = 0 }
  } = useContext(MetronomeContext)

  //For naked collaterals we have mainCollateral.address that's different from address, and we need to use collateral factor from main collateral.
  const selectedTokenMainAddress =
    selectedToken?.mainCollateral?.address || selectedToken?.address

  const collateralizationRatio = (
    collaterals.find(
      collateral => collateral.address === selectedTokenMainAddress
    ) ?? {}
  ).collateralFactor

  // estimate projected issuable limit given current rate
  if (
    ['withdraw', 'deposit'].includes(operation) &&
    usdRate &&
    metronome &&
    inputValue
  ) {
    const inputValueInUsd = Big(inputValue).times(usdRate)
    if (inputValueInUsd.gt(0) && collateralizationRatio) {
      const inputIssuableInUsd = Big(inputValueInUsd).times(
        Big(collateralizationRatio).div(100)
      )
      return operation === 'deposit'
        ? Big(issuableLimitInUsd).plus(inputIssuableInUsd)
        : Big(issuableLimitInUsd).minus(inputIssuableInUsd)
    }
    return issuableLimitInUsd
  }
  return issuableLimitInUsd
}

export default useProjectedIssuableLimitInUsd
